import React from 'react'
import logo from '../images/logo_footer.svg';

const Footer = ({ siteTitle , siteSocial }) => (
  <footer>
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}
      className="footer"
    >
    <div className="foot_descript">
      <h3 style={{ margin: 0 }}>
          <img src={logo} alt={siteTitle} className='logo updated'/> 
      </h3>
      </div>
      <div className="foot_social">
      <ul>
        <li><h3>Connect With Me</h3></li>
      {siteSocial.map(social => (
          <li key={social.node.id}><a target="_blank" rel="nofollow noopener" href={social.node.url}>{social.node.name}</a></li>
      ))}
      </ul>
      </div>
     </div>
     <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}
      className="footer"
    > 
      <span className="foot_copy">&copy; {siteTitle}</span><br/>
      <a className="analytics" href="javascript:gaOptout();">Opt Out of Google Analytics Tracking</a>
    </div>
    
  </footer>
)


export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js